import React, { useState, useEffect } from 'react';
import { getRandomProducts, API_BASE_URL } from '../API/endpoint';
import Product from './Product';

function Selection() {
  const [selection, setSelection] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedProduct, setSelectedProduct] = useState(null);

  useEffect(() => {
    loadProducts();
  }, []);

  const loadProducts = async () => {
    try {
      setLoading(true);
      const products = await getRandomProducts();
      if (Array.isArray(products)) {
        setSelection(products);
      } else {
        console.error('Unexpected products response format:', products);
        setSelection([]);
      }
    } catch (err) {
      console.error('Erreur lors du chargement des produits:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <>
        <h2 className="section-title">APERÇU DE MES CRÉATIONS</h2>
        <div className="Selection">
          <p>Chargement...</p>
        </div>
      </>
    );
  }
  return (
    <>
      <h2 className="section-title">APERÇU DE MES CRÉATIONS</h2>
      <div className="Selection">
        {selection.length === 0 ? (
          <p>Aucun produit disponible.</p>
        ) : (
          selection.map(product => (
            <div 
              key={product.id} 
              className="product" 
              onClick={() => setSelectedProduct(product)}
              style={{ cursor: 'pointer' }}
            >
              {(product.thumbnailPath || product.path) && <img src={`${API_BASE_URL}${product.thumbnailPath || product.path}`} alt={product.title} />}
              <p>{product.title}</p>
            </div>
          ))
        )}
      </div>

      {selectedProduct && (
        <div className="modal-overlay" onClick={() => setSelectedProduct(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <Product product={selectedProduct} onClose={() => setSelectedProduct(null)} />
          </div>
        </div>
      )}
    </>
  );
} ;


export default Selection;